var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dia-shop-nav__search-box-inner" },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchString,
            expression: "searchString",
          },
        ],
        ref: "searchInput",
        staticClass: "dia-shop-nav__search-input",
        attrs: {
          placeholder: _vm.$translate(
            "AbfallbehaelterXXL::Template.placeholderSearch"
          ),
          type: "search",
          "aria-label": _vm.$translate("Ceres::Template.headerSearchTerm"),
          autofocus: _vm.isShopBuilder,
        },
        domProps: { value: _vm.searchString },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.search()
          },
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.searchString = $event.target.value
            },
            function ($event) {
              return _vm.onValueChanged($event.target.value)
            },
          ],
          focus: function ($event) {
            _vm.isSearchFocused = true
          },
          blur: function ($event) {
            return _vm.onBlurSearchField($event)
          },
        },
      }),
      _vm._v(" "),
      _vm._t("search-button", function () {
        return [
          _c(
            "button",
            {
              staticClass: "dia-shop-nav__search-submit",
              attrs: {
                type: "submit",
                "aria-label": _vm.$translate("Ceres::Template.headerSearch"),
              },
              on: {
                click: function ($event) {
                  return _vm.search()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "40",
                    height: "40",
                    viewBox: "0 0 40 40",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M28.5054 26.8345C28.4574 26.7866 28.4053 26.7401 28.3505 26.6964L24.6254 23.412C26.7195 20.3047 26.3937 16.0403 23.6471 13.2937C22.1373 11.7839 20.1295 10.9521 17.9943 10.9521C15.8591 10.9521 13.8514 11.7836 12.3416 13.2937C10.8317 14.8036 10 16.8113 10 18.9465C10 21.0817 10.8314 23.0894 12.3416 24.5993C13.8514 26.1091 15.8591 26.9405 17.9943 26.9405C19.7123 26.9405 21.3472 26.4018 22.7073 25.4054C22.8338 25.3458 22.9166 25.2821 23 25.199L23.645 24.6016C23.6459 24.6008 23.6465 24.6002 23.6474 24.5993C23.6483 24.5984 23.6489 24.5978 23.6495 24.5969L23.9071 24.3393L27.5882 27.585C27.5968 27.5927 27.6057 27.5999 27.6147 27.607C27.6382 27.6255 27.6587 27.6433 27.6775 27.6624C27.8067 27.7916 27.8779 27.9635 27.8779 28.146C27.8779 28.3286 27.8067 28.5004 27.6775 28.6296C27.411 28.8965 26.9768 28.8965 26.7103 28.6296C26.6915 28.6109 26.6733 28.59 26.6546 28.5662C26.6474 28.5573 26.6403 28.5483 26.6325 28.5397L24.1263 25.6963C23.9125 25.4539 23.5426 25.4304 23.2999 25.6442C23.0572 25.8581 23.034 26.2279 23.2478 26.4706L25.7436 29.3024C25.7877 29.3578 25.8341 29.4099 25.8821 29.4578C26.2436 29.8193 26.7186 30.0001 27.1936 30.0001C27.6686 30.0001 28.1435 29.8193 28.5051 29.4578C29.2284 28.7342 29.2284 27.5576 28.5054 26.8345ZM13.1694 23.7714C11.8806 22.4825 11.1709 20.769 11.1709 18.9465C11.1709 17.124 11.8806 15.4105 13.1694 14.1216C14.4583 12.8327 16.1718 12.1231 17.9943 12.1231C19.8169 12.1231 21.5304 12.8327 22.8192 14.1216C25.4789 16.7812 25.4798 21.1085 22.8213 23.769L22.8169 23.7735C21.5283 25.0609 19.816 25.7696 17.9943 25.7696C16.1715 25.7699 14.458 25.06 13.1694 23.7714Z",
                      fill: "#F0C42E",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M29.4585 25.8824C29.4105 25.8344 29.3584 25.788 29.3036 25.7442L25.5785 22.4598C27.6726 19.3526 27.3468 15.0882 24.6002 12.3416C23.0904 10.8317 21.0827 10 18.9475 10C16.8123 10 14.8045 10.8314 13.2947 12.3416C11.7849 13.8514 10.9531 15.8591 10.9531 17.9943C10.9531 20.1295 11.7846 22.1373 13.2947 23.6471C14.8045 25.1569 16.8123 25.9884 18.9475 25.9884C20.6655 25.9884 22.3004 25.4497 23.6604 24.4533C23.787 24.3937 23.8697 24.33 23.9531 24.2469L24.5982 23.6495C24.5991 23.6486 24.5996 23.648 24.6005 23.6471C24.6014 23.6462 24.602 23.6456 24.6026 23.6447L24.8602 23.3871L28.5413 26.6328C28.5499 26.6406 28.5589 26.6477 28.5678 26.6549C28.5913 26.6733 28.6119 26.6912 28.6306 26.7103C28.7599 26.8395 28.831 27.0113 28.831 27.1939C28.831 27.3764 28.7599 27.5483 28.6306 27.6775C28.3641 27.9443 27.9299 27.9443 27.6634 27.6775C27.6446 27.6587 27.6264 27.6379 27.6077 27.6141C27.6005 27.6051 27.5934 27.5962 27.5857 27.5876L25.0794 24.7442C24.8656 24.5018 24.4957 24.4783 24.253 24.6921C24.0103 24.9059 23.9871 25.2758 24.2009 25.5185L26.6967 28.3502C26.7408 28.4056 26.7873 28.4577 26.8352 28.5057C27.1967 28.8672 27.6717 29.048 28.1467 29.048C28.6217 29.048 29.0967 28.8672 29.4582 28.5057C30.1815 27.782 30.1815 26.6054 29.4585 25.8824ZM14.1226 22.8192C12.8337 21.5304 12.1241 19.8169 12.1241 17.9943C12.1241 16.1718 12.8337 14.4583 14.1226 13.1694C15.4114 11.8806 17.125 11.1709 18.9475 11.1709C20.77 11.1709 22.4835 11.8806 23.7724 13.1694C26.432 15.8291 26.4329 20.1563 23.7745 22.8169L23.77 22.8213C22.4814 24.1087 20.7691 24.8175 18.9475 24.8175C17.1247 24.8178 15.4111 24.1078 14.1226 22.8192Z",
                      fill: "#0E0F12",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      }),
      _vm._v(" "),
      _vm.isSearchFocused
        ? [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasAutocompleteResults,
                    expression: "hasAutocompleteResults",
                  },
                ],
              },
              [
                _vm._t("autocomplete-suggestions", function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "autocomplete-suggestions shadow bg-white w-100",
                      },
                      [
                        _c("search-suggestion-item", {
                          attrs: {
                            "show-images": _vm.showItemImages,
                            "suggestion-type": "item",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                }),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }